import { refreshIcons } from '../../base/utils.js';
import { closeAllDropdowns } from './shared.js';

export function initDropdowns() {
    document.querySelectorAll('[data-toggle="dropdown"], [data-bs-toggle="dropdown"]').forEach(function (trigger) {
        if (trigger.dataset.initialized) return;
        trigger.dataset.initialized = 'true';

        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const parent = this.closest('.dropdown');
            const menu = parent ? parent.querySelector('.dropdown-menu') : this.nextElementSibling;

            closeAllDropdowns();

            if (menu && !menu.classList.contains('show')) {
                menu.classList.add('show');
            }
        });
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.dropdown-menu') && !e.target.closest('[data-toggle="dropdown"]') && !e.target.closest('[data-bs-toggle="dropdown"]')) {
            closeAllDropdowns();
        }
    });
    
    document.addEventListener('click', function (e) {
        if (e.target.closest('.dropdown-menu') && (e.target.tagName === 'INPUT' || e.target.tagName === 'LABEL' || e.target.tagName === 'TEXTAREA' || e.target.closest('form'))) {
            // inputs/labels/textareas/forms inside dropdown
        }
    });
}
